import { lazy } from "react";

const AddCamNote = lazy(() => import("../Component/CamNote/AddCamNote"));
const CamNoteList = lazy(() => import("../Component/CamNote/CamNoteList"));

const camNoteRoutes = [
  { path: "/manage-cam-note/:id", element: <AddCamNote />, protected: true },
  { path: "/manage-cam-note-list", element: <CamNoteList />, protected: true },
];

export default camNoteRoutes;
